import { useEffect } from 'react'

import { styled, createGlobalStyle } from 'styled-components'

import { authActions, useAuthIsInitializing } from 'core/auth/authStore'
import Spinner from 'core/components/lib/Spinner'

import AuthRoutesController from './AuthRoutesController'
import ToastViewport from './stores/toasts/ToastViewport'
import SystemProviders from './SystemProviders'

const GlobalStyle = createGlobalStyle`
  
  *:focus {
    outline: none;
  }

  *.focus-visible {
    box-shadow: 0 0 0 1px ${(p) => p.theme.highlight};
  }

  a {
    border-radius: 2px;
  }
`

const AppMain = styled.div`
  background-color: ${({ theme }) => theme.background};
  height: 100%;
  overflow-y: auto;
`

const CenteredSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.background};
  width: 100vw;
  height: 100vh;
`

const App = () => {
  const isInitializing = useAuthIsInitializing()

  useEffect(() => {
    void authActions.initializeSessionAndUser()
  }, [])

  if (isInitializing) {
    return (
      <CenteredSpinnerContainer>
        <Spinner />
      </CenteredSpinnerContainer>
    )
  }

  return (
    <SystemProviders>
      <GlobalStyle />
      <AppMain>
        <AuthRoutesController />
        <ToastViewport />
      </AppMain>
    </SystemProviders>
  )
}

export default App
